import Lookup from 'src/componentes/select2';

const ModeloRiscoLookup = ({ clearable = false, ...props }) => {
  return (
    <Lookup
      labelKey="descricao"
      valueKey="id"
      url="/ModeloRiscoLookup"
      clearable={clearable}
      {...props}
    />
  );
};

export default ModeloRiscoLookup;
